import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent } from '../../../common/events/identity'
import { APIBase } from '../../../identity/adapters/api-base'

declare let window: any

const FC_DATA_PATH = `/api-root/subscription/identity/fc_hashed_data/`

export interface IHashedData {
    pid: string
    data: string[][]
}
export class LiveRamp extends APIBase {
    /**
     * Initialize LiveRamp
     * @param liveRampUrl:string
     */
    public init(liveRampUrl: string) {
        let envelopeModuleReady= false

        // Fire Event when liveRamp Envelop module is ready
        window.addEventListener(IdentityEvent.ENVELOP_MODULE_READY, () => {
            envelopeModuleReady= true
            const storedData = localStorage.getItem('fcHashedData')
            if (storedData) {
                // get HashedData from localstorage
                const fcHashedObject: IHashedData = JSON.parse(storedData)
                if (fcHashedObject.data.length > 0) {
                    // set Additiom Data to liveRamp envelope
                    this.setAdditionalData(fcHashedObject.data)
                    envelopeModuleReady = false
                }
            }
        })
        document.addEventListener(IdentityEvent.SET_PERSON_ID, (data: any)=> {
            if (data.detail.pid) {
                let storedPid = ''
                // Get old hashed data
                const storedData = localStorage.getItem('fcHashedData')
                if(storedData) {
                    const storedHashedObject: IHashedData = JSON.parse(storedData)
                    storedPid = storedHashedObject.pid
                }
                // check if it is a new pid
                if (data.detail.pid !== storedPid ) {
                    // pull the new hashed data for the new pid
                    this.getHashedData(data.detail.pid)
                    .then(async (hashedData)=> {
                        if (hashedData.length > 0) {
                            const fcHashedData: IHashedData = {
                                data: hashedData,
                                pid: data.detail.pid
                            }
                            // Save or Overwrite localstorage data
                            localStorage.setItem('fcHashedData', JSON.stringify(fcHashedData))
                            if (envelopeModuleReady) {
                                this.setAdditionalData(hashedData)
                            }
                        }

                    })
                    .catch((e)=> {
                        console.log(`Unable to update Hashed Data:`, e)
                    })
                }
            }
        })
        this.loadScript(liveRampUrl)
    }
    /**
     * load LiveRamp script
     * @param url:string
     */
    public loadScript(url: string) {
        const attributes = [{
            key: 'defer',
            value: ''
        }]
        DOMUtils.loadScript(url ,attributes)
    }
    /**
     * Get Hashed Data from backend
     * @param pid: string
     *  @returns Array
     */
    public async getHashedData(pid: string) {

        if(pid) {
            const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
            const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''
            return LiveRamp.postData(FC_DATA_PATH, {pid}, csrfToken)
        }
        return []
    }
    /**
     * push Email Hashes to LiveRamp envelop
     * @param emailHashes:Array
     */
    private setAdditionalData(emailsHashes: string[][]) {
        emailsHashes.forEach((emailHashes)=> {
            if(emailHashes.length>0) {
                window.atsenvelopemodule.setAdditionalData({
                    id:emailHashes,
                    type: 'emailHashes'
                })
            }
        })
    }
}
